import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  linkTo,
  linkLabel,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 md:mb-8">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-block rounded-md bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
            {eyebrow}
          </span>
        )}
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">{subtitle}</p>
        )}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="flex items-center gap-1 rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}